module.exports = __webpack_public_path__ + "media/images/pic/testimonials/naza-cd9766c501f75b51c06ae9de5963fa62.jpg";